export default __webpack_public_path__ + "static/media/lotr.ed9483a0.png";